import { ICONS_MAP } from '../../components/constants';

import publishWarningLaborCostUrl from './publishWarningLaborCost.html';

class PublishWarningLaborCostCtrl {
  constructor(LaborUISchema, Utils) {
    'ngInject';

    Object.assign(this, { LaborUISchema, Utils });
  }

  $onInit() {
    this.data = {};

    this.schemaItems
      .filter((item) => item.calculateOnAggregated)
      .forEach((item) => {
        this.data[item.property] = this.Utils.sum(
          this.events
            .filter((event) => this.LaborUISchema.evalIf(item, { event }))
            .map((event) =>
              this.Utils.evaluateExpression(item.formula, {
                event: this.Utils.remapEventDayCost(event, { sum: true }),
              })
            )
        );
      });
  }

  getIcon(field) {
    const icon = ICONS_MAP[field.icon];
    if (!icon) {
      console.log('unsuppored field icon', field);
      return;
    }
    return icon;
  }
}

export default {
  templateUrl: publishWarningLaborCostUrl,
  controller: PublishWarningLaborCostCtrl,
  controllerAs: 'ctrl',
  bindings: {
    schemaItems: '<',
    events: '<',
  },
};
